import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as notificationsReducer } from 'reapop';
import { routerReducer } from 'react-router-redux';

import { config } from './config';
import { colors, backgroundColors } from './colors';
import { navigation } from './navigation';
import uiReducer from './ui';
import loanInfoModalReducer from './loanInfoModalReducer';
import notesModalReducer from './notesModalReducer';
import authReducer from './authReducer';
import userReducer from './userReducer';
import profiles from './profilesReducer';
import profile from './profileReducer';
import permission from './permissionReducer';
import { unnaxBackDocument, unnaxFrontDocument } from './unnaxReducer';

const rootReducer = combineReducers({
  config,
  colors,
  backgroundColors,
  navigation,
  router: routerReducer,
  notifications: notificationsReducer(),
  ui: uiReducer,
  form: formReducer,
  loanInfoModal: loanInfoModalReducer,
  notesModal: notesModalReducer,
  auth: authReducer,
  user: userReducer,
  profiles,
  profile,
  permission,
  unnaxBackDocument,
  unnaxFrontDocument,
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js